import React from 'react';
import { useTranslation } from 'react-i18next';
import { USER_TYPES } from '@medflex/utils/constants';
import Modal from '@medflex/components/stories/Modal';
import FeatureButton from '@medflex/components/stories/FeatureButton';
import {
  IconPatientAvatar,
  IconPhysicianAvatar,
  IconAssistantAvatar,
  IconUserGroup,
} from '@medflex/components/stories/Icons';
import useIsWideScreen from '@medflex/hooks/useIsWideScreen';
import useModal from '../hooks/useModal';
import { MODALS } from '../hooks/useIsModal';
import useUserProfile from '../hooks/useUserProfile';
import usePermissions from '../hooks/usePermissions';

const ContactInviteModal = () => {
  const { userProfile } = useUserProfile();
  const { type: userType } = userProfile;
  const { open, close } = useModal();
  const isWideScreen = useIsWideScreen();
  const { t } = useTranslation('physician', { keyPrefix: 'ContactInviteModal' });
  const { hasPatientAccess, hasPhysicianAccess } = usePermissions();

  return (
    <Modal
      showCloseButton
      onClickOutside={() => close({ modal: MODALS.contactInvite })}
      onClickCloseButton={() => close({ modal: MODALS.contactInvite })}
      className="flex flex-col"
    >
      <div data-component="ContactInviteModal" className="flex flex-col">
        <h2 className="font-semibold mb-4 text-xl">{t('title')}</h2>
        {hasPatientAccess && (
          <FeatureButton
            className="mb-2"
            isWidescreen={isWideScreen}
            icon={<IconPatientAvatar size="8" />}
            title={t('patient')}
            onClick={() => open({ invitePatient: 'email', modal: '' })}
          />
        )}
        {hasPhysicianAccess && (
          <FeatureButton
            className="mb-2"
            isWidescreen={isWideScreen}
            icon={<IconPhysicianAvatar size="8" />}
            title={t('physician')}
            onClick={() => open({ modal: MODALS.invitePhysician })}
          />
        )}
        {userType === USER_TYPES.PHYSICIAN && (
          <FeatureButton
            className="mb-2"
            isWidescreen={isWideScreen}
            icon={<IconAssistantAvatar size="8" />}
            title={t('team')}
            onClick={() => open({ modal: MODALS.staff_type })}
          />
        )}
        <FeatureButton
          isWidescreen={isWideScreen}
          icon={<IconUserGroup size="8" />}
          title={t('group')}
          onClick={() => open({ modal: MODALS.sessionChatCreate })}
        />
      </div>
    </Modal>
  );
};

export default ContactInviteModal;
